<template>
  <div class="vacancies_list_header vacancies_list_header_inner flex column">
      <BreadCrumb />
      <div class="vacancies_list_header--categories flex container j_sb wc-lg">
          <h2 class="f-38 bold  uppercase wc-lg">{{ _.get(content, 'title') }}</h2>
          <router-link :to="get_vacancies_link" class="vacancies_list_header--back flex a_center wc-lg" v-if="windowWidth >= 1441">
              <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="11.352" height="11.352" viewBox="0 0 11.352 11.352">
  <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M5.007.277a.946.946,0,0,0,0,1.338L8.122,4.73H.946a.946.946,0,0,0,0,1.892H8.121L5.007,9.736a.946.946,0,0,0,1.338,1.338l4.73-4.729.016-.017.008-.009.008-.008.01-.011.006-.006.011-.012,0,0,.011-.014,0,0,.011-.014,0,0,.011-.015,0,0,.01-.015,0,0,.009-.014,0-.005.008-.013,0-.007.007-.011.006-.01,0-.009.007-.013,0-.006.009-.017v0a.946.946,0,0,0-.194-1.1L6.344.277a.946.946,0,0,0-1.338,0Z" transform="translate(11.352 11.352) rotate(180)" fill="#7063e9"/>
</svg>
            <span class="f-13 bold uppercase f-light-purple">{{ $fn.tr('უკან დაბრუნება')}}</span>
          </router-link>
      </div>
      <div class="vacancies_list_header__searchbox container  flex column">
          

          <div class="vacancies_list_header__searchbox--inner flex j_sb a_center">
                  
          <div class="vacancies_list_header--tags flex">
              <div class="vacancies_list_header--tag  br-6 bg_gray flex a_center wc-lg" v-for="(tag, index) in tags" :key="index">
                  <h2 class="f-14 medium">{{_.get(tag, 'title') }}</h2>
                  <div  class="vacancies_list_header--tag__x">
                         <svg xmlns="http://www.w3.org/2000/svg" width="16.97" height="16.97" viewBox="0 0 16.97 16.97">
                    <path id="Combined_Shape" data-name="Combined Shape" d="M5,11V7H1A1,1,0,0,1,1,5H5V1A1,1,0,0,1,7,1V5h4a1,1,0,0,1,0,2H7v4a1,1,0,0,1-2,0Z" transform="translate(8.485 16.97) rotate(-135)" fill="#fff"/>
                    </svg>

                  </div>
          

              </div>

    
          </div>

                     <router-link :to="get_vacancies_link" class="vacancies_list_header--back flex a_center wc-lg" v-if="windowWidth <= 1440">
              <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="11.352" height="11.352" viewBox="0 0 11.352 11.352">
  <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M5.007.277a.946.946,0,0,0,0,1.338L8.122,4.73H.946a.946.946,0,0,0,0,1.892H8.121L5.007,9.736a.946.946,0,0,0,1.338,1.338l4.73-4.729.016-.017.008-.009.008-.008.01-.011.006-.006.011-.012,0,0,.011-.014,0,0,.011-.014,0,0,.011-.015,0,0,.01-.015,0,0,.009-.014,0-.005.008-.013,0-.007.007-.011.006-.01,0-.009.007-.013,0-.006.009-.017v0a.946.946,0,0,0-.194-1.1L6.344.277a.946.946,0,0,0-1.338,0Z" transform="translate(11.352 11.352) rotate(180)" fill="#7063e9"/>
</svg>
            <span class="f-13 bold uppercase f-light-purple">{{ $fn.tr('უკან დაბრუნება')}}</span>
          </router-link>
        
           
          </div>
      </div>
  </div>
</template>

<script>
import BreadCrumb from '@/components/smartComponents/BreadCrumb';
import resize_handler from '@/mixins/resize_handler';
export default {
    mixins: [resize_handler],
    components: {
        BreadCrumb,
    },
    data(){
        return{
   

        }
    },
    props: ['content'],
    mounted(){
        console.log(this.content)
    },
    computed: {
          
        tags(){
            let list =  this.$store.state.main.indx.terms.location.filter(tag => this.content.location.includes(tag.id));
            return list;
        },

      get_vacancies_link(){
          return this.$store.state.main.selected_menu.full_url;
      }

     
    
      

    },
    methods: {
   
    
   

       

     
    },
    watch: {
      
   

 
    }
}
</script>

